'use client';

import { htmlFrom } from '@baseball-near-you/ui';
import { toHTML } from '@portabletext/to-html';

export const renderPortableText = (blocks: any) => {
  return htmlFrom(toHTML(blocks));
};
